export default "__VITE_ASSET__BdUb6Di4__"